import OutcomeService from 'src/modules/outcome/outcomeService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'OUTCOME_FORM';

const outcomeFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: outcomeFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await OutcomeService.find(id);
      }

      dispatch({
        type: outcomeFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: outcomeFormActions.INIT_ERROR,
      });

      getHistory().push('/outcome');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: outcomeFormActions.CREATE_STARTED,
      });

      await OutcomeService.create(values);

      dispatch({
        type: outcomeFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.outcome.create.success'),
      );

      getHistory().push('/outcome');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: outcomeFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: outcomeFormActions.UPDATE_STARTED,
      });

      await OutcomeService.update(id, values);

      dispatch({
        type: outcomeFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.outcome.update.success'),
      );

      getHistory().push('/outcome');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: outcomeFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default outcomeFormActions;
